function uploadProgress({ state, input }) {
  let path = input.path
  state.set(path.concat('.value.percentComplete'), input.percentComplete)
}

export default uploadProgress



// WEBPACK FOOTER //
// ./src/modules/user/actions/uploadProgress.js